// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2947":"11b01132","4620":"2716361e","8658":"7d16b7df","8688":"ae21078d"}[chunkId] + ".chunk.css";
};